import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let configuration_id = useDataValue({
    context: 'selected',
    path: 'configuration_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      configuration_id,
    },
    pause: !configuration_id,
    requestPolicy: 'network-only',
  }
}
